import affiliates from '../api/affiliates'
import {userHasAccessToAffiliate} from "@/helpers/permissions";

export default {
  state: {
    campaignsSflAffiliates: [],
    sflAffiliates_: [],
    pendingAffiliates: [],
    ninetyPlusAffiliates: [],
    newAffiliates: [],
    affiliatesNameId: {},
    affiliatesProfile: [],
    affiliatesProfileCO: [],
    affiliatesProfileCOAll: [],
    affiliatesChat: [],
    affiliatesForAE: [],
    affiliatesForAM: [],
    affiliateEmails: {},
    affiliateTypes: {},
    affiliateStatuses: {},
    affiliatesOM: [],
    affiliateTiers: {},
    affiliateGeos: [],
    affiliateReferrers: {},
    affiliateDuplicates: {},
    filtersData: {},
    multiplySelectAffiliates:[],
    lastMassAssign: {},
    shouldUpdateColumns: false
  },
  namespaced: true,
  mutations: {
    saveMultiplySelectAffiliates(state, affiliates) {
      state.multiplySelectAffiliates.length = 0
      if (affiliates)
        state.multiplySelectAffiliates.push(affiliates)
    },
    async saveAffiliatesNameIdStore(state, data) {
      state.affiliatesNameId[data.entity] = data.affiliates
    },
    async saveSflAffiliatesStore(state, data) {
      const stateProp = data.entity + 'SflAffiliates'
      state[stateProp] = data.affiliates
    },
    async saveSflAffiliatesStore_(state, data) {
      state.sflAffiliates_ = data.affiliates
    },
    async savePendingAffiliatesStore(state, affiliates) {
      state.pendingAffiliates = affiliates
    },
    async saveNinetyPlusAffiliatesStore(state, affiliates) {
      state.ninetyPlusAffiliates = affiliates
    },
    async saveAffiliatesForAMStore(state, affiliates) {
      state.affiliatesForAM = affiliates
    },
    async saveNewAffiliatesStore(state, affiliates) {
      state.newAffiliates = affiliates
    },
    async saveAffiliatesForAEStore(state, affiliates) {
      state.affiliatesForAE = affiliates
    },
    async saveAffiliatesForChatStore(state, affiliates) {
      state.affiliatesChat = affiliates
    },
    async saveAffiliatesOMStore(state, affiliates) {
      state.affiliatesOM = affiliates
    },
    async saveAffiliatesProfileStore(state, affiliates) {
      state.affiliatesProfile = affiliates
    },
    async saveAffiliatesProfileStoreCO(state, affiliates) {
      state.affiliatesProfileCO = affiliates
    },
    async saveAffiliatesProfileStoreCOWihoutPagination(state, affiliates) {
      state.affiliatesProfileCOAll = affiliates
    },
    async saveAffiliateEmailsStore(state, data) {
      state.affiliateEmails[data.entity] = data.emails
    },
    async saveAffiliateStatusesStore(state, data) {
      state.affiliateStatuses[data.entity] = data.statuses
    },
    async saveAffiliateTypesStore(state, data) {
      state.affiliateTypes[data.entity] = data.types
    },
    async saveAffiliateTiersStore(state, data) {
      state.affiliateTiers[data.entity] = data.tiers
    },
    async saveAffiliateGeosStore(state, geos) {
      state.affiliateGeos = geos
    },
    async saveAffiliateReferrersStore(state, data) {
      state.affiliateReferrers[data.entity] = data.referrers
    },
    async saveAffiliateDuplicatesStore(state, data) {
      state.affiliateDuplicates[data.entity] = data.duplicates
    },
    async updateNinetyPlusAffiliatesStore(state, data) {
      data.affiliates = data.affiliates.split(',')

      data.affiliates.forEach((affiliateId) => {
        state.ninetyPlusAffiliates.forEach((stateAffiliatesRow, stateIndex) => {
          if (+affiliateId === stateAffiliatesRow.id) {
            state.ninetyPlusAffiliates.splice(stateIndex, 1)
          }
        })
      })
    },
    async updateNewAffiliatesStore(state, affiliates) {
      affiliates = affiliates.split(',')

      affiliates.forEach((affiliateId) => {
        state.newAffiliates.forEach((stateAffiliatesRow, stateIndex) => {
          if (+affiliateId === stateAffiliatesRow.id) {
            state.newAffiliates.splice(stateIndex, 1)
          }
        })
      })
    },
    async updatePendingAffiliateStore(state, affiliateId) {
      state.pendingAffiliates.forEach((stateAffiliatesRow, stateIndex) => {
        if (+affiliateId === stateAffiliatesRow.id) {
          state.pendingAffiliates.splice(stateIndex, 1)
        }
      })
    },
    async updateAffiliatesForAEStore(state, affiliateId) {
      state.affiliatesForAE.forEach((stateAffiliatesRow, stateIndex) => {
        if (+affiliateId === stateAffiliatesRow.id) {
          state.affiliatesForAE.splice(stateIndex, 1)
        }
      })
    },
    async updateStatusAffsForAEStore(state, affiliate) {
      state.affiliatesForAE.forEach(stateAffiliatesRow => {
        if (+affiliate.id === stateAffiliatesRow.id) {
          stateAffiliatesRow.status = affiliate.status
        }
      })
    },
    async updateAffiliatesForAMStore(state, data) {
      data.affiliates = data.affiliates.split(',')

      data.affiliates.forEach(affiliateId => {
        state.affiliatesForAM.forEach((stateAffiliatesRow, stateIndex) => {
          if (+affiliateId === stateAffiliatesRow.id) {
            state.affiliatesForAM[stateIndex].am_name = data.managerName
          }
        })
      })
    },
    async updateAffiliatesOmStore(state, affiliates) {
      affiliates = affiliates.split(',')

      affiliates.forEach((affiliateId) => {
        state.affiliatesOM.forEach((stateAffiliatesRow, stateIndex) => {
          if (+affiliateId === stateAffiliatesRow.id) {
            state.affiliatesOM.splice(stateIndex, 1)
          }
        })
      })
    },
    async updateNewAffiliateOnConfirmStore(state, affiliateId) {
      state.newAffiliates.forEach((stateAffiliatesRow, stateIndex) => {
        if (+affiliateId === stateAffiliatesRow.id) {
          state.newAffiliates[stateIndex].email_validation = ''
        }
      })
    },
    async setFilterData(state, {key, data}) {
      const filterData = {};
      filterData[key] = data;
      state.filtersData = Object.assign({}, state.filtersData , filterData);
    },
    async saveAffiliateProfile(state, data) {
      const newData = state.affiliatesProfileCO.data;
      state.affiliatesProfileCO.data.forEach((ap, index) => {
        if (data.id === ap.id) {
          const updatedObject = Object.assign(ap, data);
          updatedObject.affNameId = `${updatedObject.name} (${updatedObject.id})`;
          newData.splice(index, 1, updatedObject);
        }
      })
      state.affiliatesProfileCO = Object.assign({}, state.affiliatesProfileCO, {data: newData});
    },
    async saveAffiliateProfileVerticals(state, item) {
      const { affiliateId, verticals } = item;
      const affiliateProfile = state.affiliatesProfileCO.data.find((ap) => ap.id === affiliateId);

      if (affiliateProfile) {
        affiliateProfile.verticals = verticals;
      }
    },
    async saveAfterMassUpdate(state, data) {},
    async saveAfterMassAssign(state, data) {
      state.lastMassAssign = data;
    },
    updateColumnsList(state) {
      state.shouldUpdateColumns = !state.shouldUpdateColumns;
    }
  },
  actions: {
    async getSflAffiliates({commit}, data) {
      commit('saveSflAffiliatesStore', await affiliates.getSflAffiliatesForCampaigns(data))
    },
    async setSflAffiliatesStore({commit}, data) {
      commit('saveSflAffiliatesStore_', await affiliates.getSflAffiliatesForCampaigns(data))
    },
    async savePendingAffiliatesStore({commit}, data) {
      commit('savePendingAffiliatesStore', await affiliates.getPendingAffiliates(data))
    },
    async saveNinetyPlusAffiliatesStore({commit}, data) {
      commit('saveNinetyPlusAffiliatesStore', await affiliates.getNinetyPlusAffiliates(data))
    },
    async saveNewAffiliatesStore({commit}, data) {
      commit('saveNewAffiliatesStore', await affiliates.getNewAffiliates(data))
    },
    async saveAffiliatesForAEStore({commit}, data) {
      commit('saveAffiliatesForAEStore', await affiliates.getAffiliatesForAE(data))
    },
    async saveAffiliatesForAMStore({commit}, data) {
      commit('saveAffiliatesForAMStore', await affiliates.getAffiliatesForAM(data))
    },
    async saveAffiliatesOMStore({commit}, data) {
      commit('saveAffiliatesOMStore', await affiliates.getAffiliatesOM(data))
    },
    async getAffiliatesProfileData({commit}, data) {
      commit('saveAffiliatesProfileStore', await affiliates.getAffiliatesProfile(data))
    },
    async getAffiliatesProfileDataCO({commit, dispatch, rootState}, data) {
      try {
        const userSate = rootState.user;
        const result = await affiliates.getAffiliatesProfileCO(data);
        // check if user can be picked by manager
        // for (let affIndex in result.data) {
        //   result.data[affIndex].isSelectable = userHasAccessToAffiliate(userSate, result.data[affIndex]);
        // }
        commit('saveAffiliatesProfileStoreCO', result)
      } catch (err) {
        console.error(err);
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async getAffiliatesProfileDataCOWithoutPagination({commit, dispatch, rootState}, data) {
      try {
        const result = await affiliates.getAffiliatesProfileCO(data);
        commit('saveAffiliatesProfileStoreCOWihoutPagination', result)
      } catch (err) {
        console.error(err);
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async getAffiliatesChat({commit, dispatch, rootState}, data) {
      try {
        const result = await affiliates.getAffiliatesProfileCO(data);
        commit('saveAffiliatesForChatStore', result)
      } catch (err) {
        console.error(err);
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveAffiliateGeosStore({commit}, data) {
      commit('saveAffiliateGeosStore', await affiliates.getAffiliateGeos(data))
    },
    async getAffiliateDuplicates({commit}, data) {
      commit('saveAffiliateDuplicatesStore', await affiliates.getAffiliateDuplicates(data))
    },
    async getAffiliatesNameId({commit}, data) {
      commit('saveAffiliatesNameIdStore', await affiliates.getAffiliatesNameId(data))
    },
    async getAffiliateEmails({commit}, data) {
      commit('saveAffiliateEmailsStore', await affiliates.getAffiliateEmails(data))
    },
    async getAffiliateStatuses({commit}, data) {
      commit('saveAffiliateStatusesStore', await affiliates.getAffiliateStatuses(data))
    },
    async getAffiliateReferrers({commit}, data) {
      commit('saveAffiliateReferrersStore', await affiliates.getAffiliateReferrers(data))
    },
    async getAffiliateTypes({commit}, data) {
      commit('saveAffiliateTypesStore', await affiliates.getAffiliateTypes(data))
    },
    async getAffiliateTiers({commit}, data) {
      commit('saveAffiliateTiersStore', await affiliates.getAffiliateTiers(data))
    },
    async updateAffiliatesAm({commit}, data) {
      commit('updateNinetyPlusAffiliatesStore', await affiliates.updateAffiliatesAm(data))
    },
    async reassignToAnotherAM({commit}, data) {
      commit('updateAffiliatesForAMStore', await affiliates.reassignAffiliatesAm(data))
    },
    async updateAffiliatesAe({commit}, data) {
      commit('updateNewAffiliatesStore', await affiliates.updateAffiliatesAe(data))
    },
    async updateAffiliatesOM({commit}, data) {
      commit('updateAffiliatesOmStore', await affiliates.updateAffiliatesOM(data))
    },
    async reassignPendingAffiliate({commit}, data) {
      commit('updatePendingAffiliateStore', await affiliates.updateAffiliatesAe(data))
    },
    async reassignToAnotherAE({commit}, data) {
      commit('updateAffiliatesForAEStore', await affiliates.updateAffiliatesAe(data))
    },
    async approveAffiliate({commit}, data) {
      commit('updatePendingAffiliateStore', await affiliates.approveAffiliate(data))
    },
    async confirmEmail({commit}, data) {
      commit('updateNewAffiliateOnConfirmStore', await affiliates.confirmEmail(data))
    },
    async rejectNewAffiliates({commit}, data) {
      commit('updateNewAffiliatesStore', await affiliates.rejectAffiliates(data))
    },
    async rejectPendingAffiliates({commit}, data) {
      commit('updatePendingAffiliateStore', await affiliates.rejectAffiliates(data))
    },
    async suspendAffiliates({commit}, data) {
      commit('updateStatusAffsForAEStore', await affiliates.updateAffsForAEStatus(data))
    },
    async unsuspendAffiliates({commit}, data) {
      commit('updateStatusAffsForAEStore', await affiliates.updateAffsForAEStatus(data))
    },
    async getFilterData({commit, dispatch}, data) {
      try {
        commit('setFilterData', {key: data.name, data: await affiliates.getFilter(data)}) // await affiliates.getFilter(data)
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveAffiliateProfile({commit, dispatch, rootState}, data) {
      try {
        commit('saveAffiliateProfile', await affiliates.updateAffiliateProfile(data));
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    async massUpdate({commit, dispatch}, data) {
      commit('saveAfterMassUpdate', await affiliates.massUpdate(data))
    },
    async massAssign({commit, dispatch}, data) {
      commit('saveAfterMassAssign', await affiliates.massAssign(data));
    },
    async saveAffiliateInfo({commit, dispatch, rootState}, data) {
      try {
        await affiliates.updateAffiliateInfo(data);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    async saveAffiliateInfoGotzha({commit, dispatch, rootState}, data) {
      try {
        await affiliates.updateAffiliateInfoGotzha(data);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    async syncUserHubspotGotzha({commit, dispatch, rootState}, data) {

      try {
        await affiliates.syncUserHubspot(data);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    updateColumnsList({commit, dispatch, rootState}) {
      commit('updateColumnsList');
    }
  },
  getters: {
    getPendingAffiliates: state => state.pendingAffiliates,
    getNinetyPlusAffiliates: state => state.ninetyPlusAffiliates,
    getNewAffiliates: state => state.newAffiliates,
    getAffiliatesForAE: state => state.affiliatesForAE,
    getAffiliatesForAM: state => state.affiliatesForAM,
    getAffiliatesOM: state => state.affiliatesOM,
    getAffiliatesProfile: state => state.affiliatesProfile,
    getAffiliatesProfileCO: state => state.affiliatesProfileCO,
    getAffiliatesChat: state => state.affiliatesChat,
    getAffiliatesNameId: state => state.affiliatesNameId,
    getAffiliateEmails: state => state.affiliateEmails,
    getAffiliateStatuses: state => state.affiliateStatuses,
    getAffiliateTypes: state => state.affiliateTypes,
    getAffiliateTiers: state => state.affiliateTiers,
    getAffiliateGeos: state => state.affiliateGeos,
    getAffiliateReferrers: state => state.affiliateReferrers,
    getAffiliateDuplicates: state => state.affiliateDuplicates,
    filtersData: state => state.filtersData,
    getSflAffiliates_: state => state.sflAffiliates_,
    getMultiplySelectAffiliates: state => state.multiplySelectAffiliates,
    getShouldUpdateColumns: state => state.shouldUpdateColumns,
    getAllAffiliates: state => state.affiliatesProfileCOAll
  },

}
